// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../sharedmodules/services/fetch';
import { handleError } from '../../../sharedmodules/services/error-handlers';

const basePath = '/api';

export async function deleteAdminNotification(getAccessToken, id) {

    const endPoint = `${basePath}/notifications/${id}`;
    const accessToken = await getAccessToken();

    const options = {
        headers: {
            Authorization: accessToken ? `Bearer ${accessToken}` : '',
            'content-type': 'application/json',
        },
        method: 'DELETE',
    };

    try {

        const response = await fetchService.fetch(endPoint, options);
        return await response;

    } catch (error) {

        return (error.status === 400 || error.status === 404) ?
            Promise.reject(error) :
            handleError(error);

    }

}
